// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import PrimaryButton from "./PrimaryButton";

const DeleteAccountModal = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight mt-1 mb-4">Enter phrase “DELETE” to confirm <br /> that you want to delete account.</p>
      <InputField label="Phrase" className="mb-8" />
      <PrimaryButton label="Delete" className="py-2 w-full rounded-3xl from-[#FF542E] to-[#FF542E] border-[#FF542E]" />
    </>
  );
};

export default DeleteAccountModal;